export default __webpack_public_path__ + "static/media/Chart-7-1.d7898cf9.svg";